import { KeyboardShortcut, normalizeKeyboardShortcut } from '../../utils/keyboardShortcuts'
import { getOperatingSystem } from '../../utils/operatingSystem'
import { astraTwMerge } from '../Utilities/astraTwMerge'

type Variant = 'default' | 'inverted'

type Props = {
    shortcut: KeyboardShortcut
    variant?: Variant
}

const variantStyles: Record<Variant, string> = {
    default: 'bg-neutral-rest border border-muted text-muted',
    inverted: 'bg-surface-base/15 border border-transparent text-inverted',
}

const SHIFT_SYMBOL = '⇧'

const getMetaSymbol = () => (getOperatingSystem() === 'Mac' ? '⌘' : 'Ctrl')

export const KeyboardShortcutPreview = ({ shortcut, variant = 'default' }: Props) => {
    const keys: string[] = []
    if (shortcut.hasShift) {
        keys.push(SHIFT_SYMBOL)
    }
    if (shortcut.hasMeta) {
        keys.push(getMetaSymbol())
    }
    keys.push(normalizeKeyboardShortcut(shortcut.keyboardKey))

    return (
        <span
            className={astraTwMerge(
                `inline-flex w-fit min-w-5 items-center justify-center gap-px rounded px-0.5 text-center text-xs font-medium ${variantStyles[variant]}`
            )}
        >
            {keys.map(key => (
                // wrapped so the flex gap applies between keys instead of collapsing them into one text run
                <span key={key}>{key}</span>
            ))}
        </span>
    )
}
